import { arrayOf, shape, string } from "prop-types";

import Categories from "../Categories";

const Text = ({ code, options }) => {
  switch (code) {
    case "category_ids": {
      return (
        <Categories dataT1="categories_text" options={options} code={code} />
      );
    }
    default: {
      return null;
    }
  }
};

Text.propTypes = {
  code: string.isRequired,
  options: arrayOf(shape({})).isRequired,
};

export default Text;
